import {Injectable} from '@angular/core';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {AlertsFilter} from '../models/alerts-filter.model';
import {Observable} from 'rxjs/Observable';
import {Utilities} from '@shared/utilities/utilities.model';
import {Alerts} from 'app/delivery/models/alerts.model';
import {Alert} from '../models/alert.model';
import {RequestMethod, RequestOptionsArgs, Response} from '@angular/http';
import {ListService} from '@shared/models/list-service.model';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';

@Injectable()
export class AlertsService implements ListService {

	environment: AppConfigEnvironment;

	private currentPreCompletedAlert: Alert;
	private currentPreCompletedAlert_old: Alert;
	private alertForSpecificCheck: any;

	constructor(private httpAuthService: HttpAuthService,
				private selectCommoditiesService: SelectCommoditiesService,
				private appConfig: AppConfigEnvironmentService) {
		this.environment = appConfig.Environment;
	}

	setPreCompletedAlert(alert: Alert): void {
		this.currentPreCompletedAlert = alert;
	}

	setPreCompletedAlert_old(alert: Alert): void {
		this.currentPreCompletedAlert_old = alert;
	}

	getCurrentPreCompletedAlert(): Alert {
		const res: Alert = this.currentPreCompletedAlert;
		this.currentPreCompletedAlert = null;
		return res;
	}

	getCurrentPreCompletedAlert_old(): Alert {
		const res: Alert = this.currentPreCompletedAlert_old;
		this.currentPreCompletedAlert_old = null;
		return res;
	}

	setAlertFroSpecificCheck(alertForSpecificCheck: any): void {
		this.alertForSpecificCheck = alertForSpecificCheck;
	}

	getAlertFroSpecificCheck(): any {
		const res: any = this.alertForSpecificCheck;
		this.alertForSpecificCheck = null;
		return res;
	}

	/*getList(alertsFilter?: AlertsFilter): Observable<Alerts> {
		let url: string = environment.GW_API + '/alerts';
		if (alertsFilter) {
			url = url + alertsFilter.getFilterUrl();
		}
		const options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<Alerts>(
			observer => {
				this.httpAuthService.get(url, environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							try {
								observer.next(new Alerts(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}*/

	getList(alertsFilter: AlertsFilter): Observable<Alerts> {
		let url: string = this.environment.GW_API + '/alerts/threads';
		if (alertsFilter) {
			url = url + alertsFilter.getFilterUrl();
		}
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<Alerts>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							try {
								observer.next(new Alerts(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					}
				);
			}
		);
	}


	getAlertsByOrder(orderID: number): Observable<Alert[]> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/alerts';
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<Alert[]>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							const json: any = response.json();
							const alerts: Alert[] = [];
							json.alerts.forEach(
								a => alerts.push(a)
							);
							observer.next(alerts);
						} else {
							observer.next(null);
						}
					},
					error => {
						console.error(error);
						observer.next(null);
					}
				);
			}
		);
	}

	getThread(idThread: string): Observable<Alert[]> {
		const url: string = this.environment.GW_API + '/alerts/thread/' + encodeURIComponent(idThread);
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<Alert[]>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							try {
								const alerts: Alert[] = [];
								const model: any = response.json();
								if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
									model.items.forEach(alert => alerts.push(new Alert(alert)));
								}
								observer.next(alerts);
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					}
				);
			}
		);
	}

	sendAlert(body: any): Observable<Response> {
		const url: string = this.environment.GW_API + '/alerts';
		return this.sendPost(url, body);
	}

	setAlertRead(alertID: any, body: any): Observable<Response> {
		const url: string = this.environment.GW_API + '/alerts/' + alertID;
		return this.sendPost(url, body);
	}

	private sendPost(url: string, body: any): Observable<Response> {
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		options.method = RequestMethod.Post;
		options.headers.set('Content-Type', 'application/json');

		return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, options);
	}

}
